import { render, staticRenderFns } from "./KExternalLink.vue?vue&type=template&id=d931b82e&scoped=true&"
import script from "./KExternalLink.vue?vue&type=script&lang=js&"
export * from "./KExternalLink.vue?vue&type=script&lang=js&"
import style0 from "./KExternalLink.vue?vue&type=style&index=0&id=d931b82e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d931b82e",
  null
  
)

component.options.__file = "KExternalLink.vue"
export default component.exports